import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { motion } from "motion/react";
import { ease } from "@connect/component-library/utils/animations";
import { Heading } from "@connect/component-library/components/heading";
export const BottomSheetPanel = t0 => {
  const $ = _c(15);
  const {
    title,
    onClose,
    children
  } = t0;
  const panelRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const previous = document.activeElement;
      panelRef.current?.focus();
      return () => {
        if (previous instanceof HTMLElement) {
          previous.focus();
        }
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== onClose) {
    t3 = event => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      y: "100%"
    };
    t5 = {
      y: 0
    };
    t6 = {
      y: "100%"
    };
    t7 = {
      duration: 0.4,
      ease
    };
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== title) {
    t8 = <Heading level={2} size="md">{title}</Heading>;
    $[8] = title;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== children || $[11] !== t3 || $[12] !== t8 || $[13] !== title) {
    t9 = <motion.div ref={panelRef} role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} onKeyDown={t3} initial={t4} animate={t5} exit={t6} transition={t7} className="absolute inset-x-0 bottom-0 top-36 flex flex-col rounded-t-sheet bg-surface-strong px-5 pt-6 outline-none">{t8}{children}</motion.div>;
    $[10] = children;
    $[11] = t3;
    $[12] = t8;
    $[13] = title;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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